window.app = window.app || {};

window.app.communityBlock = {
  el: {
    blocks: document.querySelectorAll('.mt-community__block'),
    carousel: document.querySelector('.mt-community__carousel .swiper'),
    carouselNavigation: document.querySelectorAll('.mt-community__nav-btn')
  },
  config: [
    { 992: [200, 0, -100], 768: [100, 0, -50] },
    { 992: [290, 80, -150], 768: [150, 0, -50] },
    { 992: [210, 100, -30], 768: [30, 0, -30] },
    { 992: [260, 0, -180], 768: [60, 0, -60] },
    { 992: [240, 0, -400], 768: [30, 0, -60] },
    { 992: [120, 0, -250], 768: [40, 0, -40] },
    { 992: [150, 0, -480], 768: [80, 0, -140] },
    { 992: [205, 0, -420], 768: [20, 0, -180] },
    { 992: [120, 0, -110], 768: [90, 0, -90] }
  ],
  sliderStatus: 'playing',

  parallax: function() {
    const _this = this;
    if (_this.el.blocks.length === 0) return;

    window.onload = function() {
      lax.init();
      lax.addDriver('scrollY', () => window.scrollY);

      for (let i = 0; i < _this.config.length; i++) {
        lax.addElements(`.mt-community__block:nth-child(${i+1})`, {
          scrollY: {
            translateY: [
              ["elInY", "elCenterY", "elOutY"],
              { 768: _this.config[i]['768'], 992: _this.config[i]['992'] }
            ]
          }
        });
      }
    }
  },

  init: function() {
    const _this = this;

    if (_this.el.blocks.length > 0) _this.parallax();
    if (_this.el.carousel) {
      _this.slider = new Swiper(_this.el.carousel, {
        slidesPerView: 2,
        spaceBetween: 8,
        loop: true,
        direction: 'horizontal',
        freeMode: true,
        allowTouchMove: true,
        speed: Number(_this.el.carousel.dataset.speed),
        a11y: false,
        grabCursor: true,
        preventClicks: false,
        preventClicksPropagation: false,
        autoplay: {
          delay: 1,
          pauseOnMouseEnter: false,
          disableOnInteraction: true
        },
        breakpoints: {
          460: {
            slidesPerView: 3
          },
          600: {
            slidesPerView: 4
          },
          850: {
            slidesPerView: 5
          },
          1000: {
            slidesPerView: 6,
            spaceBetween: 16,
            speed: Math.round(Number(_this.el.carousel.dataset.speed) * 1.666)
          },
          1800: {
            slidesPerView: 7,
            spaceBetween: 16,
            speed: Math.round(Number(_this.el.carousel.dataset.speed) * 1.833)
          }
        }
      });

      if ( _this.el.carouselNavigation.length > 0) {
        _this.el.carouselNavigation.forEach(button => {
          button.addEventListener('click', e => {
            e.preventDefault();
            _this.slider.autoplay.stop();
            _this.sliderStatus = 'paused';
            setTimeout(_this.slider.slideToClosest(0), 0);
            if (button.classList.contains('mt-community__nav-btn--prev')) {
              _this.slider.slidePrev(300, () => this.el.carousel.classList.add('manual'));
            } else {
              _this.slider.slideNext(300, () => this.el.carousel.classList.add('manual'));
            }
          });
        });
      }

      const isElementOutViewport = el => {
        const rect = el.getBoundingClientRect();
        return rect.bottom < 0 || rect.right < 0 || rect.left > window.innerWidth || rect.top > window.innerHeight;
      };
      const isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
      const updateAutoplay = () => {
        const playingVidCount = [...document.querySelectorAll('.mt-community__slide video')].filter(video => isVideoPlaying(video)).length;
        if (playingVidCount === 0 && _this.sliderStatus === 'paused') {
          _this.el.carousel.classList.remove('manual');
          _this.slider.autoplay.start();
          _this.slider.update();
          _this.slider.slideToLoop(_this.slider.realIndex + 1);
          _this.sliderStatus = 'playing';
        }
      };

      document.addEventListener('click', e => {
        (!e.target.classList.contains('mt-community--carousel') && !e.target.closest('.mt-community--carousel')) && updateAutoplay(); 

        if (e.target.classList.contains('mt-community__video-overlay')) {
          const slide = e.target.closest('.mt-community__slide');
          const video = slide.querySelector('video');

          if (isVideoPlaying(video)) {
            video.pause();
            slide.classList.remove('active');
            updateAutoplay();
          } else {
            video.play();
            slide.classList.add('active');
            _this.slider.autoplay.stop();
            _this.sliderStatus = 'paused';
          }
        }
      });

      document.addEventListener('scroll', () => {
        const playingVid = [...document.querySelectorAll('.mt-community__slide video')].filter(video => isVideoPlaying(video));

        if (isElementOutViewport(_this.el.carousel)) {
          playingVid.forEach(video => {
            video.closest('.mt-community__slide').classList.remove('active');
            video.pause();
          });
          updateAutoplay();
        } 
      });
    }
  }
}
window.app.communityBlock.init();